import { render } from "./Mycollection.vue?vue&type=template&id=1f11b085&scoped=true"
import script from "./Mycollection.vue?vue&type=script&lang=js"
export * from "./Mycollection.vue?vue&type=script&lang=js"

import "./Mycollection.vue?vue&type=style&index=0&id=1f11b085&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1f11b085"

export default script